interface Zone {
  name: string;
  isVip?: boolean;
  price: string;
  priceWithFee: string;
}

interface ZoneTableProps {
  zones: Zone[];
  activeZone: string | null;
  onZoneHover: (zone: string | null) => void;
}

export default function ZoneTable({ zones, activeZone, onZoneHover }: ZoneTableProps) {
  return (
    <div className="w-full">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-gray-300">
            <th className="text-left text-xs font-bold text-gray-600 py-2 px-3">ZONA</th>
            <th className="text-center text-xs font-bold text-gray-600 py-2 px-3">DESCONTOS</th>
            <th className="text-center text-xs font-bold text-gray-600 py-2 px-3">VISIBILIDADE</th>
            <th className="text-center text-xs font-bold text-gray-600 py-2 px-3">MARCAÇÃO</th>
            <th className="text-right text-xs font-bold text-gray-600 py-2 px-3">PREÇO</th>
          </tr>
        </thead>
        <tbody>
          {zones.map((zone) => (
            <tr
              key={zone.name}
              className={`border-b border-gray-200 cursor-pointer transition-colors ${
                activeZone === zone.name
                  ? "bg-gray-100"
                  : zone.isVip
                  ? "bg-amber-50 hover:bg-amber-100"
                  : "hover:bg-gray-50"
              }`}
              onMouseEnter={() => onZoneHover(zone.name)}
              onMouseLeave={() => onZoneHover(null)}
            >
              <td className="py-4 px-3">
                <div className="flex items-center gap-2">
                  <span className={`text-sm ${zone.isVip ? "font-semibold" : "text-gray-700"}`}>
                    {zone.name}
                  </span>
                  {zone.isVip && (
                    <span className="bg-amber-400 text-white text-xs font-black px-1.5 py-0.5 leading-none">
                      VIP
                    </span>
                  )}
                </div>
              </td>
              <td className="py-4 px-3 text-center text-gray-500">-</td>
              <td className="py-4 px-3 text-center text-gray-500">-</td>
              <td className="py-4 px-3 text-center text-gray-500">-</td>
              <td className="py-4 px-3 text-right">
                <div className={`font-bold text-base ${zone.isVip ? "text-amber-600" : "text-gray-900"}`}>
                  {zone.price}
                </div>
                <div className="text-xs text-gray-500">({zone.priceWithFee})</div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
